import styled from 'styled-components';
import Modal from '@mindtickle/modal';
import { THEME } from '../../config/constants';

export const StyledModal = styled(Modal)`
  &.fullpage-modal {
    padding: 0;

    .${THEME.prefixCls}-modal-body {
      padding: 0;

      .loader-wrp {
        height: calc(100vh - 48px);
        display: flex;
      }
    }
    max-width: 100vw;
  }
`;
